import { configureStore } from '@reduxjs/toolkit';
import authenticationSlice from '../features/auth/authenticationSlice';
import userSlice from '../features/auth/userSlice';
import changeLanguageSlice from '../features/language/changeLanguageSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import statusSlice from '../features/routeState/useRouteState'


const authPersistConfig = {
  key: 'auth',
  storage,
}

const userPersistConfig = {
  key: 'user',
  storage,
}

const routePersistConfig = {
  key: 'enabled',
  storage,
}

const AuthPersistedReducer = persistReducer(authPersistConfig, authenticationSlice);
const UserPersistedReducer = persistReducer(userPersistConfig, userSlice);
const routeReducer = persistReducer(routePersistConfig, statusSlice)

export const store = configureStore({
  reducer: {
    auth: AuthPersistedReducer,
    languageId: changeLanguageSlice,
    user: UserPersistedReducer,
    enableRoute: routeReducer,
  },
  middleware: [thunk]
});

export const persister = persistStore(store);
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch